<template>
  <div>
    <l-tile-layer
        ref="lGeneral"
        :url="urlGeneral"
        attribution="OSM"
        :options="optGeneralLayer"
    />

  </div>

</template>

<script>
import {LTileLayer} from 'vue2-leaflet'

export default {
  name: "Cartografia",
  data() {
    return {
      optGeneralLayer: {
        minZoom: 8,
        maxZoom: 18
      },
      urlGeneral: 'http://b.tile.thunderforest.com/transport/{z}/{x}/{y}.png?apikey=688cca8bf9c94e2f8e039b65ad69395f',
    }
  },
  components: {
    LTileLayer
  }
}
</script>

<style scoped>

</style>